import { AlertService } from 'app/core';
import { HttpErrorResponse } from '@angular/common/http';
import * as moment from 'moment';

export class BaseComponent {
	constructor(protected alertService: AlertService) {}

	public handleError(error: HttpErrorResponse): void {
		if (typeof error.error === 'string') {
			this.alertService.addError(error.error);
		}

		if (error.error instanceof Blob) {
			const reader: FileReader = new FileReader();
			//reader.onload(this.handleRead);
			reader.onload = (e: ProgressEvent) => {
				const text: string = (<any>e.target).result;
				if (error.error.type === 'text/plain') {
					this.alertService.addError(text);
				} else {
					console.error(error);
					console.error(text);
					this.alertService.addError(
						`An error occurred processing this request. Please contact support and let them know the error occurred ${moment
							.utc()
							.format()}`
					);
				}
			};

			reader.readAsText(error.error);
		}

		if (typeof error.error === 'object') {
			this.alertService.addError(Object.values(error.error.errors).join(',  '));
		}
	}
}
